import type { ReactNode } from "react";

import { Badge } from "@/components/ui/badge";
import { Centered } from "@/components/ui/container";
import { Loader } from "@/components/ui/loader";
import { Text } from "@/components/ui/text";
import { useConfig } from "@/lib/config";

export function AuthLayout({
  children,
  title,
  isLoading = false,
  hideTestBadge,
}: {
  children: ReactNode;
  title: string;
  isLoading?: boolean;
  hideTestBadge?: boolean;
}) {
  const config = useConfig();
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-linear-to-br from-background to-accent">
      <div className="relative flex flex-col items-center bg-background border rounded-md shadow-xl p-8 w-[420px] mx-5 sm:mx-0">
        <div className="flex justify-center w-full">
          <img
            src={config.logoUrl}
            style={{ objectFit: "contain", maxWidth: "100%", maxHeight: 40 }}
            alt="logo"
          />
        </div>
        <div className="flex items-center mt-3 gap-2">
          <Text elementType="h1" size="lg" bold>
            {title}
          </Text>
          {config.testEnv && !hideTestBadge && (
            <Badge className="align-middle">Test</Badge>
          )}
        </div>
        {children}
        {isLoading && (
          <Centered className="absolute inset-0 bg-background/75">
            <Loader size="medium" />
          </Centered>
        )}
      </div>
    </div>
  );
}
